import React from 'react';

const FooterHome = ({footerText}) => {
  return (
    <footer className=" text-white">
      <div className="home">
        <div className="container mx-auto">
          <div className="flex justify-center">
            <div className="text-center">
              <p>
              {footerText}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterHome;